export const isStringArray = (data: unknown): data is string[] =>
    Array.isArray(data) && data.every((item) => typeof item === 'string');
